import { render, staticRenderFns } from "./ScalePlusWhatsNew.vue?vue&type=template&id=69425412"
import script from "./ScalePlusWhatsNew.vue?vue&type=script&lang=js"
export * from "./ScalePlusWhatsNew.vue?vue&type=script&lang=js"
import style0 from "./ScalePlusWhatsNew.vue?vue&type=style&index=0&id=69425412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports